import { responsiveBreakpoints } from '@apps/registry/common/utils/responsiveHelpers';
import { animationTransition } from '@shared/utils/animationTransition';
import { styled, Box, Flex, TopBar, LinkV1, StyleSystemProps } from '@withjoy/joykit';

export const StyledIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  padding: 5px;
`;

export const StyledTopBar = styled(TopBar)`
  width: 100%;
  border-bottom: none;
`;

export const StyledShopBox = styled(Box)`
  cursor: pointer;
`;

export const StyledFlex = styled(Flex)`
  overflow-x: scroll;
  height: calc(100vh - 74px);
`;
export const StyledFlexHorizontalScroll = styled(Flex)`
  margin: auto;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 24px;
  padding-left: 24px;
  position: absolute;
  bottom: -30px;
`;

export const StyledFlexHorizontalWrapper = styled(Box)`
  position: relative;
  overflow: hidden;
`;

export const StyledLink = styled(LinkV1)<{ color: string }>`
  > span > p {
    transition: ${animationTransition('color')};
    color: ${props => props.color} !important;
  }
  > span > p:hover {
    color: ${props => props.theme.colors.typeTertiaryDark} !important;
  }
  > span > p:active {
    color: ${props => props.theme.colors.linkHover} !important;
  }
`;

export const Wrapper = styled.div`
  margin-right: 24px;
  @media screen and (min-width: ${responsiveBreakpoints.SIZE_1280}) {
    margin-right: 64px;
  }
`;

export const storefrontNavigatorPlacementStyles: StyleSystemProps = {
  position: 'relative',
  height: 64,
  backgroundColor: 'mono2',
  color: 'black'
};
